<template>
<div :class="{'androidMode': isAndroidMode(), 'layout-gom': layoutGom}">
    <CircleButton
        style="margin:auto; display:block"
        :icon='minus_white'
        :disabled="disabledMinus"
        :big="iconesGrandes"
        @circleBtnClick="handleRemoveClick" v-if="disableControll !== true">
    </CircleButton>
    <span class="item_quantity" :class="{'big-mode': iconesGrandes}" v-text="quantity"></span>
    <CircleButton
        style="margin:auto; display:block"
        :icon='plus_white'
        :disabled="disabledPlus"
        :big="iconesGrandes"
        @circleBtnClick="handleAddClick" v-if="disableControll !== true">
    </CircleButton>
</div>
</template>

<script>

import CircleButton from '@/components/CircleButton'
import Util from '@/assets/libs/util'

export default {
    name: 'QuantityControl',
    components: {
        CircleButton
    },
    data () {
        return {
            minus_white: require('../../static/icons/minus_white.svg'),
            plus_white: require('../../static/icons/plus_white.svg'),
            iconesGrandes: Util.getLocalConfigs('iconesGrandes')
        }
    },
    props: ['quantity', 'disabledMinus', 'disabledPlus', 'disableControll', 'layoutGom'],
    methods: {
        handleAddClick: function () {
            this.$emit('circleBtnAdd')
        },
        handleRemoveClick: function () {
            this.$emit('circleBtnRemove')
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    div {
        display: flex;
        max-width: 200px;

        CircleButton {
            width: 50px;
        }

        span {
            width: 100px;
            font-size: 2rem;
            font-weight: bold;
            margin: auto;
            display: block;
            text-align: center;
        }
        .item_quantity.big-mode {
            font-size: 3.0rem;
        }
    }

    .layout-gom {
        display: flex;
        justify-content: space-between;
        min-width: 10px;
        max-width: 180px;
        span {
            min-width: min-content;
            margin: 0;
        }
        button {
            margin: 0 !important;
            border-radius: 50%;
        }
    }

    @media (max-width: 698px) { // Gertec SK210
        div {
            min-width: 90px;
            max-width: 105px;
            span {
                font-size: 20px !important;
            }
        }
    }

    @media (min-width: 699px) and (max-width: 1025px) { //@tablet
        div {
            width: 130px;

            CircleButton {
                width: 50px;
            }

            span {
                width: 70px;
                font-size: 25px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/QuantityControl.vue